import React, { useCallback, useEffect, useState } from 'react';
import { BottomNav } from './components/BottomNav';
import { HomePage } from './pages/HomePage';
import { BlastoScreen } from './pages/BlastoScreen';
import { InterventionScreen } from './pages/InterventionScreen';
import { VictoryScreen } from './pages/VictoryScreen';
import { CheckInScreen } from './pages/CheckInScreen';
import { PartnerScreen } from './pages/PartnerScreen';
type Screen = 'home' | 'blasto' | 'intervention' | 'victory' | 'checkin' | 'partner';
type Trigger = 'bored' | 'lonely' | 'angry' | 'stressed' | 'tired' | 'other';
type NavTab = 'home' | 'checkin' | 'partner';
// Mock partner data for MVP
const MOCK_PARTNER = {
  username: 'Brother_7392',
  lastCheckInDate: 'Today, 2:30 PM',
  achievements: ['salah', 'quran', 'exercise', 'dhikr'],
  status: 'clean-strong'
};
function getStoredCount(): number {
  try {
    const stored = localStorage.getItem('urgeBeatenCount');
    return stored ? parseInt(stored, 10) : 0;
  } catch {
    return 0;
  }
}
function setStoredCount(count: number): void {
  try {
    localStorage.setItem('urgeBeatenCount', count.toString());
  } catch {
    // localStorage unavailable
  }
}
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('home');
  const [selectedTrigger, setSelectedTrigger] = useState<Trigger>('other');
  const [urgeBeatenCount, setUrgeBeatenCount] = useState<number>(getStoredCount);
  // Determine which nav tab is active
  const activeNavTab: NavTab = currentScreen === 'checkin' ? 'checkin' : currentScreen === 'partner' ? 'partner' : 'home';
  const handlePanicPress = useCallback(() => {
    setCurrentScreen('blasto');
  }, []);
  const handleSelectTrigger = useCallback((trigger: Trigger) => {
    setSelectedTrigger(trigger);
    setCurrentScreen('intervention');
  }, []);
  const handleUrgeBeaten = useCallback(() => {
    const newCount = urgeBeatenCount + 1;
    setUrgeBeatenCount(newCount);
    setStoredCount(newCount);
    setCurrentScreen('victory');
  }, [urgeBeatenCount]);
  const handleGoHome = useCallback(() => {
    setCurrentScreen('home');
  }, []);
  const handleNavigation = useCallback((screen: NavTab) => {
    setCurrentScreen(screen);
  }, []);
  const handleCheckInSubmit = useCallback((achievements: string[], status: string | null) => {
    try {
      localStorage.setItem('lastCheckIn', JSON.stringify({
        achievements,
        status,
        date: new Date().toISOString()
      }));
    } catch {
      // localStorage unavailable
    }
  }, []);
  // Show bottom nav on main screens only (not during panic flow)
  const showBottomNav = ['home', 'checkin', 'partner'].includes(currentScreen);
  return <div className="w-full min-h-screen bg-background" data-id="element-0">
      <div className="max-w-md mx-auto relative min-h-screen" data-id="element-1">
        {currentScreen === 'home' && <HomePage onPanicPress={handlePanicPress} onCheckInPress={() => setCurrentScreen('checkin')} urgeBeatenCount={urgeBeatenCount} hasPartner={true} partnerName={MOCK_PARTNER.username} partnerStatus="Clean and strong • Checked in today" data-id="element-2" />}

        {currentScreen === 'blasto' && <BlastoScreen onSelectTrigger={handleSelectTrigger} data-id="element-3" />}

        {currentScreen === 'intervention' && <InterventionScreen trigger={selectedTrigger} onUrgeBeaten={handleUrgeBeaten} data-id="element-4" />}

        {currentScreen === 'victory' && <VictoryScreen urgeBeatenCount={urgeBeatenCount} onGoHome={handleGoHome} data-id="element-5" />}

        {currentScreen === 'checkin' && <CheckInScreen onSubmit={handleCheckInSubmit} data-id="element-6" />}

        {currentScreen === 'partner' && <PartnerScreen partner={MOCK_PARTNER} data-id="element-7" />}

        {showBottomNav && <BottomNav activeTab={activeNavTab} onNavigate={handleNavigation} data-id="element-8" />}
      </div>
    </div>;
}